import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../core/services/auth.service';

export interface ContractUnit {
  _id: string;
  title_en: string;
  title_ar: string;
  unitNumber: string;
  id: string;
}

export interface SeekerContractItem {
  _id: string;
  type: string;
  typeLabel: string;
  status: string;
  unit: ContractUnit | string | null;
  startDate?: string;
  endDate?: string;
  rentAmount?: number;
  finalPrice?: number;
  paymentMethod?: string;
  paymentSummary?: {
    totalAmount: number;
    totalPaid: number;
    totalRemaining: number;
  };
  contractDocument?: Record<string, unknown>;
  createdAt: string;
}

export interface SeekerContractsResponse {
  contracts: SeekerContractItem[];
}

@Injectable({ providedIn: 'root' })
export class SeekerContractsService {
  private baseUrl = environment.api.baseUrl;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  getContracts(): Observable<SeekerContractsResponse> {
    const token = this.authService.getAccessToken();
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    return this.http.get<SeekerContractsResponse>(`${this.baseUrl}/portal/my-contracts`, {
      headers,
    });
  }
}
